//export const initialState = {};
export const initialState = {
    user: null,
    partner: null,
    data: null,
    authenticated: false,
    redirectOn: false,
}